import React from 'react';
import {
    Upload,
    Review,
    Errors,
    Success,
    VesselPositionSummary,
} from 'components/forms/sections';
import {Route} from 'react-router-dom';
import ProgressForm from 'components/forms/ProgressForm';
import {FormNames, FormTypes} from 'constants.js';
import {StatePrompt} from 'components/forms';
import fields from './fields';
import {mapFieldLabels} from 'components/utils/field-label-mappings';
//import {getSections} from 'components/forms/AutoSection';
import {Signature, ShipmentAndDischarge} from './sections';
import {Branch, BranchGroup, Loop} from '../navigation';
import getVesselInForm from '../vessel/VesselInForm';

const fieldLabelMappings = mapFieldLabels(fields);

const FormNOAATOSS = () => {
    const node = FormTypes.NOAATOSS.toLowerCase();
    //const sections = getSections(fields);

    return (
        <ProgressForm title={FormNames.NOAATOSS} node={node}>
            <StatePrompt />
            <Route path={`/forms/${node}/upload`}>
                <Upload documentType='ssl' />
            </Route>
            <Route path={`/forms/${node}/signature`}>
                <Signature />
            </Route>

            {/* Vessel info section */}
            <Loop node='vessel_entries'>
                {getVesselInForm(node, true)}
                {/* Position Info */}
                <Loop node='service_entries'>
                    {/* Service Entries section */}
                    <Route path={`/forms/${node}/shipment-discharge`}>
                        <ShipmentAndDischarge />
                    </Route>
                    <Route path={`/forms/${node}/vessel-position-summary`}>
                        <VesselPositionSummary />
                    </Route>
                </Loop>

                <Route path={`/forms/${node}/review`}>
                    <Review
                        showFormInfo
                        fieldLabelMappings={fieldLabelMappings}
                        ssl
                        endpointOverride={'ssl'}
                        isEnd
                        allowEdit
                    />
                </Route>
            </Loop>

            <BranchGroup>
                <Branch when={(state, response) => response?.errors?.length}>
                    <Route path={`/forms/${node}/errors`}>
                        <Errors />
                    </Route>
                </Branch>
                <Branch when={(state, response) => !response?.errors?.length}>
                    <Route path={`/forms/${node}/success`}>
                        <Success />
                    </Route>
                </Branch>
            </BranchGroup>
        </ProgressForm>
    );
};

export default FormNOAATOSS;
